import { Link } from 'react-router-dom-v5-compat'
import { Button, ShopgridIcon } from '@buffer-mono/popcorn'
import { BufferTrackerReact } from '@buffer-mono/tracking-plan'
import { useSelectedChannel } from '../ChannelContext'

export function GridPreviewButton(): JSX.Element | null {
  const channel = useSelectedChannel()

  if (channel.service === 'instagram' && channel.type !== 'profile') {
    return (
      <Button
        id="grid-preview"
        variant="secondary"
        size="large"
        as={Link}
        to={`/channels/${channel.id}/shop-grid`}
        onClick={(): void => {
          BufferTrackerReact.instagramGridPreviewIconClicked({
            product: 'publish',
            clientName: 'publishWeb',
            channelId: channel.id,
          })
        }}
      >
        <ShopgridIcon />
        Grid
      </Button>
    )
  }

  return null
}
